import styled from 'styled-components'

import { color } from 'src/styles/colors'
import { fontWeight } from 'src/styles'
import { Z_INDEX_QUESTION } from 'src/constants/z-indexes'
import { media } from 'src/styles/media'

export const UnorderedList = styled.ul`
  position: absolute;
  padding: 0;
  margin: 0;
  background-color: ${color.VERY_LIGHT_PINK};
  border-radius: 1.6rem;
  top: 100%;
  right: 0;

  ${media.desktop} {
    z-index: ${Z_INDEX_QUESTION};
  }
`

export const ListItem = styled.li`
  list-style-type: none;
  white-space: nowrap;
  margin: 1rem 2rem;
`

export const Button = styled.button`
  color: ${color.WARM_GREY};
  font-weight: ${fontWeight.EXTRA};
`
